import { registerComponent } from '../app'
import { CART_UPDATED } from '../events'

const ShowOnCart = (scope, el) => {
	const props = {
		visibleClass: 'visible'
	}

	scope.on(CART_UPDATED, data => {
		data.items.length
			? el.classList.add(props.visibleClass)
			: el.classList.remove(props.visibleClass)
	})
}

registerComponent('show-on-cart', ShowOnCart)
